/*
  PA kombin -> sepet koprusu  (28 Agu 2026, v2)

  ESKI SURUMUN HATASI: quick-cart section'inin innerHTML'ini disaridan degistirip
  cart linkine programatik tikliyordu. Tema (Stiletto) drawer'i yuklenirken bir kez
  baglar; innerHTML degisince tema kopuk DOM dugumune referans tutar. Sonuc:
  drawer acilmiyor, sayac guncellenmiyor, scroll kilidi yarim kaliyor (drawer
  acikken arka plan kayiyor).

  YENI YONTEM: temanin resmi uygulama kancasi. document uzerine
  "apps:product-added-to-cart" event'i gonderilir; tema hem header sayacini
  gunceller hem refreshQuickCart() ile drawer icerigini KENDI guvenli yontemiyle
  tazeler (baglar korunur). Ardindan header sepet ikonuna tiklanir; temanin
  kendi dinleyicisi "quick-cart:open" yayinlar ve drawer saglikli acilir.
  Tema araya girmezse tarayici /cart'a gider - o da kabul edilebilir yedek akis.
*/
(function () {
  window.PAKombinCart = {
    applyCode: function (code) {
      return code
        ? fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
            .then(function () {})
            .catch(function () {})
        : Promise.resolve();
    },
    refreshAndShow: function () {
      if (location.pathname.indexOf('/cart') === 0) {
        location.reload();
        return true;
      }
      if (!document.querySelector('.quick-cart')) return false;
      try {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      } catch (e) {
        return false;
      }
      setTimeout(function () {
        var trig = document.querySelector(
          'header a[href="/cart"], .header a[href="/cart"], [data-quick-cart-trigger]'
        );
        trig && trig.click();
      }, 350);
      return true;
    }
  };
})();
